var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarshadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 945,
    height: 414,
    viewBox: "0 0 945 414",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_13_6430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M696.056 334.513C686.831 368.941 521.859 354.65 327.581 302.594C133.302 250.537 -242.225 99.4282 -233 65C-223.775 30.5718 626.722 192.944 821 245.001C1015.28 297.057 705.281 300.085 696.056 334.513Z",
    fill: "#5B5B5B",
    fillOpacity: 0.71
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13_6430",
    x: -293.167,
    y: 0.25293,
    width: 1238.04,
    height: 413.021,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_13_6430"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarshadow);
export default __webpack_public_path__ + "static/media/calendarshadow.3c6b67e6b1b496f509bb5de85481a21d.svg";
export { ForwardRef as ReactComponent };